import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenesysCloudPlatformApiService } from '../../common/services/genesys-cloud-platform-api.service';
import { IntegrationsResponse } from '../models/integration.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsApiService {
  static readonly IntegrationsPath = 'api/v2/integrations';

  protected constructor(protected readonly api: GenesysCloudPlatformApiService) {}

  getIntegrations$(): Observable<IntegrationsResponse> {
    const path = `${IntegrationsApiService.IntegrationsPath}`;
    return this.api.get$<IntegrationsResponse>(path);
  }
}
